// extracted by mini-css-extract-plugin
module.exports = {"Footer":"_3as26","Container":"_2Zwfi","LinksContainer":"_3C3_Q","Link":"_2AXYW"};